'use client'

import { useState } from 'react'
import { useBranding } from '@/context/BrandingContext'
import { cn } from '@/lib/utils'

/** Logos wider than this are "mark + wordmark"; the compact variant shows the left square. */
const WIDE_LOGO_RATIO = 1.6

interface BrandLogoProps {
  /** `mark` is the compact square icon used when the sidebar is collapsed. */
  variant?: 'full' | 'mark'
  className?: string
}

/** The logo uploaded in Settings. Renders nothing when none has been uploaded. */
export function BrandLogo({ variant = 'full', className }: BrandLogoProps) {
  const { branding } = useBranding()
  const [isWide, setIsWide] = useState(false)

  if (!branding.logoSrc) return null

  return (
    <img
      src={branding.logoSrc}
      alt={branding.companyName}
      onLoad={(event) => {
        const { naturalWidth, naturalHeight } = event.currentTarget
        setIsWide(naturalHeight > 0 && naturalWidth / naturalHeight > WIDE_LOGO_RATIO)
      }}
      className={cn(className, variant === 'mark' && isWide && 'object-cover object-left')}
    />
  )
}
